<div class="uni-form-field__verified">
  <uni-icon class="uni-form-field__verified-icon" [style]="'far'" name="check"></uni-icon>
  <div class="uni-form-field__verified-text">{{ 'label.verified' | translate }}</div>
</div>
